// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1AppObjectSchema } from './v1/appObjectSchema';

export const listAppObjectsPathParamsSchema = z.object({
  app_id: z.number().int().describe("AppUser id"),
});

export const listAppObjectsHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description List of app objects
 */
export const listAppObjects200Schema = z.array(z.lazy(() => v1AppObjectSchema));

export const listAppObjectsQueryResponseSchema = z.lazy(() => listAppObjects200Schema);
